import React, { useState } from "react";
import styles from "./Packages.module.css";
import image1 from "../../Images/noimage.jpeg"; // Example images, replace with actual dynamic images from backend
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import OFF from "../../Images/OFF.svg";

const Packages = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate(); // Import navigate hook
  const { Packages, loading } = useSelector((state) => state.PackagesSlice);
  console.log("Packages", Packages);

  // Show either first 8 or all cards based on the state
  const cardsToDisplay = showAll
    ? Array.isArray(Packages)
      ? Packages
      : []
    : Array.isArray(Packages)
    ? Packages.slice(0, 8)
    : [];

  const onSubmit = (card) => {
    console.log("card", card);
    navigate("/PackageDetails", { state: { card } });
  };
  return (
    <>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner
            animation="border"
            role="status"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      ) : (
        <div>
          {Array.isArray(Packages) && Packages.length > 0 ? (
            <div className={styles.cardContainer}>
              {cardsToDisplay.map((card, index) => (
                <div
                  key={index}
                  className={styles.card}
                  onClick={() => {
                    onSubmit(card);
                  }}
                >  
                 {card?.itm_dessal*100 > 0 &&<div
                className={styles.offBadge}
                style={{
                  right: "auto",
                  left: "5px",
                }}
              >
                <img
                  src={OFF}
                  alt="Discount"
                  className={styles.offImage}
                />
                <div className={styles.offText}>
                <div>{card?.itm_dessal*100}%</div>
                <div>OFF</div>
                </div>
              </div>}
                  <img
                    src={(card?.itm_IMG && card?.itm_IMG?.trim() !="" ) ? `https://reservation.ladycaresa.com/public/uploads${card.itm_IMG}` : image1}
                    alt={card.label}
                    className={styles.cardImage}
                  />

                  <div className={styles.labelsConatiner}>
                    <div className={styles.cardLabel}>
                      <span className={styles.cardLabelSpan}>
                        {currentLanguage === "ar"
                          ? `${card?.itm_nam?.trim()} `
                          : card?.itm_enm?.trim() !== ""
                          ? `${card?.itm_enm?.trim()} `
                          : `${card?.itm_nam?.trim()} `}
                      </span>
                    </div>
                    <div className={styles.cardLabel2}>
                      <span className={styles.cardLabelSpan2}>
                        {currentLanguage === "ar"
                          ? card?.itm_descr1
                            ? card.itm_descr1.trim()
                            : card?.itm_descr2
                            ? card.itm_descr2.trim()
                            : ""
                          : null}
                      </span>
                    </div>
                  </div>

                  <div className={styles.buttonContainer}>
                    <div className={styles.button}>
                      <span style={{ margin: "0 5px" }}>
                        {parseFloat(Number(card?.prcandtax).toFixed(2))}
                      </span>
                      <span>{t("rs")}</span>
                    </div>
                  </div>
                  <div className={styles.PriceForMobile}>
                    <span style={{ margin: "0 5px" }}>
                      {parseFloat(Number(card?.prcandtax).toFixed(2))}
                    </span>
                    <span>{t("rs")}</span>
                  </div>
                </div>
              ))}
              {/* Button to toggle between Show More / Show Less */}
              <div
                className={styles.showMoreButton}
                onClick={() => setShowAll(!showAll)}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  width: "100%",
                  color: "#0066BA",
                  textDecoration: "Underline",
                  cursor: "pointer",
                  margin: "0 10px",
                }}
              >
                {Packages?.length > 8 && (
                  <span>{showAll ? t("showLess") : t("more")}</span>
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "28px",
                fontWeight: "900",
                margin: "70px",
              }}
            >
              {t("ThereAreNoOffersAvailableNow")}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Packages;
